module.exports = __webpack_public_path__ + "img/cheers.e8d11a17.png";